export { WrappedDeviceLtsFirmwareWarning } from "./warning-large";
